import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=b4d170a2&lang=pug"
import script from "./Topic.vue?vue&type=script&lang=ts"
export * from "./Topic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports